import styled from 'styled-components'
import { Box } from '../../../core-components'
import { getTextStyleCss } from '../../../core-components/text/helpers'
import { sharedInputCss, sharedInputContainerCss } from '../helpers'

type Variant = 'regular' | 'ghost' | 'nested'

const zeroWidthSpace = '​'
export const BaseTextAreaAutoExpander = styled(Box)<{ $size?: 'regular' | 'large' }>`
  visibility: hidden;
  white-space: pre-wrap;
  word-break: break-word;

  ${({ $size }) =>
    getTextStyleCss($size === 'large' ? 'form-value-multiline-l' : 'form-value-multiline')}
  // When the last line is empty, the height of the textarea is not correct, we need to add some content to fix it
  ::after {
    content: '${zeroWidthSpace}';
  }
`
export const BaseTextArea = styled(Box)<{
  hasError: boolean
  variant: Variant
  $size: 'regular' | 'large'
}>`
  resize: none;

  ${sharedInputCss}
  ${({ $size }) =>
    getTextStyleCss($size === 'large' ? 'form-value-multiline-l' : 'form-value-multiline')}
  ::placeholder {
    ${({ $size }) =>
      getTextStyleCss($size === 'large' ? 'form-value-multiline-l' : 'form-value-multiline')}
  }
`
export const BaseTextAreaWrapper = styled(Box)<{ hasError: boolean; variant: Variant }>`
  display: grid;
  overflow: hidden;
  ${sharedInputContainerCss}
`
